<template>
  <li class="w-max">
    <ul
      class="flex flex-col md:gap-4 gap-[16px]"
    >
      <FooterNavItem
        v-for="link in chapter.links"
        :key="link.title"
        :link="link"
      />
    </ul>
  </li>
</template>

<script setup>
import FooterNavItem from "./FooterNavItem.vue";

defineProps({
  chapter: {
    type: Object,
    required: true,
  },
});

</script>

<style lang="scss" scoped>
.nav-active {
  display: flex !important;
}
</style>
